(function webpackUniversalModuleDefinition(root, factory) {
   //export module comment
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash/includes"), require("lodash/debounce"), require("lodash/throttle"), require("lodash/isFunction"), require("lodash/isArray"), require("lodash/repeat"), require("lodash/range"), require("lodash/last"));
   //export module comment
	else if(typeof define === 'function' && define.amd)
		define(["lodash/includes", "lodash/debounce", "lodash/throttle", "lodash/isFunction", "lodash/isArray", "lodash/repeat", "lodash/range", "lodash/last"], factory);
   //export module comment
	else if(typeof exports === 'object')
		exports["Arthur"] = factory(require("lodash/includes"), require("lodash/debounce"), require("lodash/throttle"), require("lodash/isFunction"), require("lodash/isArray"), require("lodash/repeat"), require("lodash/range"), require("lodash/last"));
   //export module comment
	else
		root["Arthur"] = factory(root["lodash/includes"], root["lodash/debounce"], root["lodash/throttle"], root["lodash/isFunction"], root["lodash/isArray"], root["lodash/repeat"], root["lodash/range"], root["lodash/last"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_27__, __WEBPACK_EXTERNAL_MODULE_28__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/Arthur/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

var _includes = __webpack_require__(2);
var querystring_1 = __webpack_require__(12);

exports.InternalUrlReg = /^(https?:)?\/\/([\w-]+\.jianshu\.(?:io|com)|jianshu-(?:dev\.u|staging)\.qiniudn\.com)\/upload_images\//;
exports.ImageMarkDownReg = /!\[(.*?)]\((.+?)(?:\s['|"](.+?)['|"])?\)/gi;

function getFileFromDataURL(dataURL) {
    var arr = dataURL.split(',');
    var info = arr[0];
    var data = arr[1];
    var isBase64 = _includes(info, 'base64');
    var mimeType = info.match(/:([\w\W]*?);/)[1];
    var fileName = mimeType.replace('/', '.');
    var byteString = isBase64 ? atob(data) : querystring_1.unescape(data);
    var int8Arr = new Uint8Array(byteString.length);
    int8Arr.forEach(function (v, i) {
        int8Arr[i] = byteString.charCodeAt(i);
    });
    var blob = new Blob([int8Arr], {
        type: mimeType
    });
    blob.name = fileName;
    return blob;
}
exports.getFileFromDataURL = getFileFromDataURL;
function isDataURL(url) {
    return (/^data:/.test(url)
    );
}
exports.isDataURL = isDataURL;
function getUUID() {
    var now = +new Date();

    var random = (~~(Math.random() * (1 << 24))).toString(16);
    return random + "-" + now;
}
exports.getUUID = getUUID;
function getSuccessResult(image, url) {
    if (image.src) {
        var img = image;
        var alt = img.alt || 'image';
        var title = img.title ? " \"" + img.title + "\"" : '';
        return "![" + alt + "](" + url + title + ")";
    } else {
        var img = image;
        var alt = img.image.name || 'image';
        return "![" + alt + "](" + url + ")";
    }
}
exports.getSuccessResult = getSuccessResult;
function getFailResult(image) {
    return "[\u56FE\u7247\u4E0A\u4F20\u5931\u8D25...(image-" + image.id + ")]";
}
exports.getFailResult = getFailResult;
function replaceValueWithKey(obj) {
    var result = {};
    for (var k in obj) {
        if (obj.hasOwnProperty(k)) {
            result[k] = k;
        }
    }
    return result;
}
exports.replaceValueWithKey = replaceValueWithKey;
function checkImageInFence(array, offset, start) {
    if (start === void 0) {
        start = 0;
    }
    var arr = array.slice(start, start + 2);
    if (arr.length <= 1) {
        return false;
    }
    if (arr[0] < offset && offset < arr[1]) {
        return true;
    } else {
        start += 2;
        return checkImageInFence(array, offset, start);
    }
}
exports.checkImageInFence = checkImageInFence;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

var _includes = __webpack_require__(2);
var BrowserDetector_1 = __webpack_require__(3);
var common_1 = __webpack_require__(0);
var PasteUtil_1 = __webpack_require__(15);
var fileTag = 'Files';
exports.urlTag = 'text/uri-list';
var htmlTag = 'text/html';
var textTag = 'text/plain';
var imgTag = 'image/tiff';
var publicUrlTag = 'public.url';
var rtfTag = 'text/rtf';
var hasImage = function hasImage(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.querySelectorAll('img').length > 0;
};
var hasLink = function hasLink(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div.querySelectorAll('a').length > 0;
};

function getTransferData(dataTransfer, e) {
    var result = {
        type: 'text',
        value: ''
    };
    var types = dataTransfer.types,
        files = dataTransfer.files,
        items = dataTransfer.items;
    var hasFile = _includes(types, fileTag);
    var hasUrl = _includes(types, exports.urlTag);
    var hasHTML = _includes(types, htmlTag);
    var hasText = _includes(types, textTag);
    var hasImg = _includes(types, imgTag);
    var hasPublicUrl = _includes(types, publicUrlTag);
    var hasRTF = _includes(types, rtfTag);
    if (hasRTF && !hasHTML) {
        result.type = 'text';
    } else if (hasFile) {
        result.type = 'file';

        if (files && files.length > 0) {
            result.value = [].map.call(files, function (file) {
                return file;
            });
        } else if (items && items.length) {
            var fileItem = [].filter.call(items, function (item) {
                return item.kind === 'file';
            });
            result.value = fileItem.map(function (item) {
                return item.getAsFile();
            });
        }
    } else if (hasUrl) {
        var url = dataTransfer.getData(exports.urlTag);
        if (BrowserDetector_1.isSafari()) {
            if (e.type === 'drop') {
                result.type = hasPublicUrl ? 'text' : 'url';
                result.value = url;
            } else if (e.type === 'paste') {
                if (hasImg) {
                    result.type = 'url';
                    result.value = url;
                } else {
                    if (common_1.isDataURL(url)) {
                        result.type = 'url';
                        result.value = '';
                    }
                }
            }
        } else {
            var html = dataTransfer.getData(htmlTag);

            if (hasImage(html)) {
                result.type = 'url';
                result.value = url;
            }
        }
    } else if (hasImg && BrowserDetector_1.isSafari()) {
        var paste_1 = new PasteUtil_1.default(e.target);
        return new Promise(function (resolve) {
            paste_1.getImage().then(function (data) {
                result.type = 'file';
                result.value = [data.blob];
                resolve(result);
            });
        });
    } else if (hasHTML) {
        var html = dataTransfer.getData(htmlTag);

        if (hasImage(html) || hasLink(html)) {
            result.type = 'html';
            result.value = html;
        } else if (hasText) {
            result.type = 'text';
            result.value = dataTransfer.getData(textTag);
        }
    } else if (hasText) {
        result.type = 'text';
        result.value = dataTransfer.getData(textTag);
    }
    return result;
}
exports.getTransferData = getTransferData;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

var navigator = window.navigator;
var fireFoxReg = /firefox/i;
var chromeReg = /chrome/i;
var safariReg = /safari/i;
function isFirefox() {
    return fireFoxReg.test(navigator.userAgent);
}
exports.isFirefox = isFirefox;
function isChrome() {
    return chromeReg.test(navigator.userAgent);
}
exports.isChrome = isChrome;
function isSafari() {
    return safariReg.test(navigator.userAgent) && !isChrome();
}
exports.isSafari = isSafari;
function canUseSelection() {
    var textarea = document.createElement('textarea');
    return !isNaN(textarea.selectionStart);
}
exports.canUseSelection = canUseSelection;
function canInsertText() {
    return !isFirefox() && document.queryCommandSupported('insertText');
}
exports.canInsertText = canInsertText;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [0, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });

var autosize = __webpack_require__(5);
var _debounce = __webpack_require__(6);
var _throttle = __webpack_require__(7);
var _isFunction = __webpack_require__(8);
var _isArray = __webpack_require__(9);
var _repeat = __webpack_require__(10);
var Clipboard_1 = __webpack_require__(11);
var DropData_1 = __webpack_require__(16);
var DataTransfer_1 = __webpack_require__(1);
var MarkDown_1 = __webpack_require__(17);
var BrowserDetector_1 = __webpack_require__(3);
var TextHandler_1 = __webpack_require__(26);
var common_1 = __webpack_require__(0);
var keyCode_1 = __webpack_require__(29);
var EventEmitter_1 = __webpack_require__(30);
var events = {
    CONTENT_CHANGE: Symbol('contentChange'),
    DRAG_ENTER: Symbol('dragEnter'),
    DRAG_LEAVE: Symbol('dragLeave'),
    DROP: Symbol('drop'),
    ERROR: Symbol('error'),
    NOTIFY: Symbol('notify'),
    IMAGE_UPLOAD: Symbol('imageUpload'),
    EXTERNAL_IMAGE_UPLOAD: Symbol('externalImageUpload')
};
var Arthur = function () {
    function Arthur(el, options) {
        this.emitter = new EventEmitter_1.default();
        this.isInit = false;
        this.el = el;
        this.options = __assign({
            autoResize: true,
            fileSize: 5 * 1024 * 1024,
            wait: 500
        }, options);
        this.images = [];
        this.inputDebounce = _debounce(this.doInput.bind(this), this.options.wait);
        this.doKeyDown = this.doKeyDown.bind(this);
        this.doDragEnter = this.doDragEnter.bind(this);
        this.doDragLeave = this.doDragLeave.bind(this);
        this.doDragOver = _throttle(this.doDragOver.bind(this), 200);
        this.doDrop = this.doDrop.bind(this);
        this.pasteImage = this.pasteImage.bind(this);
    }
    Arthur.prototype.init = function () {
        if (!this.isInit) {
            this.isInit = true;
            var autoResize = this.options.autoResize;
            this.setAutoResize(autoResize);
            this.content = this.el.value;
            this.el.addEventListener('input', this.inputDebounce, false);
            this.el.addEventListener('keydown', this.doKeyDown, false);
            window.addEventListener('dragstart', function (e) {
                var target = e.target,
                    dataTransfer = e.dataTransfer;

                if (BrowserDetector_1.isSafari() && target instanceof HTMLImageElement) {
                    dataTransfer.clearData();
                    dataTransfer.setData(DataTransfer_1.urlTag, target.src);
                }
            }, false);
            this.el.addEventListener('dragenter', this.doDragEnter, false);
            this.el.addEventListener('dragleave', this.doDragLeave, false);
            this.el.addEventListener('dragover', this.doDragOver, false);
            this.el.addEventListener('drop', this.doDrop, false);
            this.el.addEventListener('paste', this.pasteImage, false);
            this.emitter.startEmit();
        }
    };
    Arthur.prototype.destroy = function () {
        this.inputDebounce.cancel();
        this.el.removeEventListener('input', this.inputDebounce, false);
        this.el.removeEventListener('keydown', this.doKeyDown, false);
        this.el.removeEventListener('dragenter', this.doDragEnter, false);
        this.el.removeEventListener('dragleave', this.doDragLeave, false);
        this.el.removeEventListener('dragover', this.doDragOver, false);
        this.el.removeEventListener('drop', this.doDrop, false);
        this.el.removeEventListener('paste', this.pasteImage, false);
        this.isInit = false;
        this.images = [];
        this.emitter.stopEmit();
    };
    Arthur.prototype.getContent = function () {
        return this.el.value;
    };
    Arthur.prototype.setContent = function (content) {
        this.content = this.el.value = content;
    };

    Arthur.prototype.setAutoResize = function (auto) {
        this.options.autoResize = auto;
        if (auto) {
            autosize(this.el);
        } else {
            autosize.destroy(this.el);
        }
    };
    Arthur.prototype.onEvent = function (type, fn) {
        var symbol = events[type];
        if (type && symbol && _isFunction(fn)) {
            this.emitter.on(symbol, fn);
        }
    };
    Arthur.prototype.checkExternalImages = function () {
        var content = this.content;
        var images = [];
        var dotArray = [];
        content.replace(/```/g, function (match, offset) {
            dotArray.push(offset);
            return match;
        });
        var newContent = content.replace(common_1.ImageMarkDownReg, function (match, alt, url, title, offset) {
            if (!common_1.InternalUrlReg.test(url)) {
                var id = common_1.getUUID();
                var placeholder = "[\u7AD9\u5916\u56FE\u7247\u4E0A\u4F20\u4E2D...(image-" + id + ")]";
                var image = {
                    id: id,
                    src: url,
                    placeholder: placeholder,
                    alt: alt || 'image',
                    title: title
                };
                if (common_1.checkImageInFence(dotArray, offset)) {
                    return match;
                }
                images.push(image);
                return placeholder;
            } else {
                return match;
            }
        });
        if (images.length > 0) {
            TextHandler_1.replaceAllPlaceholder(this.el, content, newContent);
            this.addImages(images, 'EXTERNAL_IMAGE_UPLOAD');
        }
        return images;
    };
    Arthur.prototype.restImage = function () {
        return this.images.length;
    };
    Arthur.prototype.isUploading = function () {
        return this.images.length !== 0;
    };
    Arthur.prototype.notify = function (msg) {
        this.emitter.emit(events.NOTIFY, msg);
    };
    Arthur.prototype.error = function (msg) {
        this.emitter.emit(events.ERROR, msg);
    };
    Arthur.prototype.afterUpload = function (obj, done) {
        var id = obj.id,
            data = obj.data;
        var image = this.images.filter(function (img) {
            return img.id === id;
        })[0];
        var restImages = this.images.filter(function (img) {
            return img.id !== id;
        });
        if (done) {
            var result = common_1.getSuccessResult(image, data.url);
            var isFirst = image.isFirst;
            var alt = image.alt || image.image.name || 'image';
            TextHandler_1.replaceAllPlaceholder(this.el, image.placeholder, result, alt, isFirst);
        } else {
            var result = common_1.getFailResult(image);
            var pos = TextHandler_1.replaceAllPlaceholder(this.el, image.placeholder, result);
            TextHandler_1.resetSelection(this.el, pos);
            this.error(data);
        }
        this.images = restImages;
    };
    Arthur.prototype.uploadSuccess = function (obj) {
        this.afterUpload(obj, true);
    };
    Arthur.prototype.uploadFail = function (obj) {
        this.afterUpload(obj, false);
    };
    Arthur.prototype.doUploadImage = function (images, type) {
        type = type || 'IMAGE_UPLOAD';
        var uploadData = [];
        images.forEach(function (image) {
            var data = { id: image.id };
            if (image.image) {
                data.file = image.image;
            } else {
                data.url = image.src;
            }
            uploadData.push(data);
        });
        this.emitter.emit(events[type], uploadData, this.uploadSuccess.bind(this), this.uploadFail.bind(this));
    };
    Arthur.prototype.addImages = function (images, type) {
        var _this = this;
        images.forEach(function (image, index) {
            image.isFirst = index === 0;
            _this.images.push(image);
        });
        this.doUploadImage(images, type);
    };
    Arthur.prototype.doInput = function (e) {
        var newContent = e.target.value;
        var content = this.content;
        if (content !== newContent) {
            this.content = newContent;
            this.emitter.emit(events.CONTENT_CHANGE, content, newContent);
        }
    };
    Arthur.prototype.doDragEnter = function (e) {
        this.emitter.emit(events.DRAG_ENTER, e);
    };
    Arthur.prototype.doDragLeave = function (e) {
        this.emitter.emit(events.DRAG_LEAVE, e);
    };

    Arthur.prototype.doDragOver = function (e) {
        e.preventDefault();
        return false;
    };
    Arthur.prototype.doDrop = function (e) {
        this.dropImage(e);
        this.emitter.emit(events.DROP, e);
    };
    Arthur.prototype.doKeyDown = function (e) {
        if (e.keyCode === keyCode_1.default.TAB) {
            if (this.insertTab(e)) {
                e.preventDefault();
            }
        }
    };
    Arthur.prototype.insertTab = function (e, tabSize) {
        if (tabSize === void 0) {
            tabSize = 2;
        }
        var isShift = e.shiftKey || false;
        var text = _repeat(' ', tabSize);
        if (isShift) {
            TextHandler_1.deleteSpace(this.el, 2);
        } else {
            TextHandler_1.insertText(this.el, text);
        }
        return BrowserDetector_1.canInsertText() || BrowserDetector_1.canUseSelection();
    };
    Arthur.prototype.getValidImages = function (files) {
        var _this = this;

        var allImages = [].filter.call(files, function (file) {
            var isImage = file.type.match(/^image\/(jpe?g|png|gif)/i);
            if (!isImage) {
                _this.notify(Arthur.Errors.FILE_TYPE_ERROR);
            }
            return !!isImage;
        });

        return allImages.filter(function (image) {
            var isTooLarge = image.size >= _this.options.fileSize;
            if (isTooLarge) {
                _this.notify(Arthur.Errors.FILE_TOO_LARGE);
            }
            return !isTooLarge;
        });
    };
    Arthur.prototype.getImageFiles = function (files) {
        var images = this.getValidImages(files);
        return images.map(function (image, i) {
            var uuid = common_1.getUUID();

            if ({}.toString.call(image) === '[object Blob]' && !image.name) {
                image.name = 'image.png';
            }
            return {
                image: image,
                id: uuid,
                placeholder: "[\u56FE\u7247\u4E0A\u4F20\u4E2D...(" + image.name + "-" + uuid + "-" + i + ")]"
            };
        });
    };
    Arthur.prototype.uploadImagesInFile = function (files) {
        var imageFiles = this.getImageFiles(files);
        if (imageFiles.length > 0) {
            var placeholder = imageFiles.map(function (image) {
                return image.placeholder;
            }).join('\n\n');
            TextHandler_1.insertText(this.el, placeholder + "\n");
            this.addImages(imageFiles);
        }
    };
    Arthur.prototype.uploadImagesInUrl = function (url) {
        if (common_1.isDataURL(url)) {
            var file = common_1.getFileFromDataURL(url);
            this.uploadImagesInFile([file]);
        } else {
            var uuid = common_1.getUUID();
            var placeholder = "[\u56FE\u7247\u4E0A\u4F20\u4E2D...(image-" + uuid + ")]";
            var image = {
                id: uuid,
                src: url,
                placeholder: placeholder,
                alt: 'image'
            };
            TextHandler_1.insertText(this.el, placeholder + "\n");
            this.addImages([image]);
        }
    };
    Arthur.prototype.uploadImagesInHtml = function (MdObj) {
        var md = MdObj.md;
        var images = MdObj.images;
        TextHandler_1.insertText(this.el, md + "\n");
        if (images.length > 0) {
            var imageData = images.map(function (image) {
                var src = image.src;
                if (common_1.isDataURL(src)) {
                    var file = common_1.getFileFromDataURL(src);

                    return {
                        id: image.id,
                        image: file,
                        placeholder: image.placeholder
                    };
                } else {
                    return image;
                }
            });
            this.addImages(imageData);
        }
    };
    Arthur.prototype.dropImage = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var data, type, value, files, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4, DropData_1.getDropData(e)];
                    case 1:
                        data = _a.sent();
                        if (!data) {
                            return [2];
                        }
                        e.stopPropagation();
                        type = data.type, value = data.value;
                        if (type === 'file') {
                            e.preventDefault();
                            files = value;
                            if (_isArray(files) && files.length > 0) {
                                this.uploadImagesInFile(files);
                            }
                        } else if (type === 'url') {
                            e.preventDefault();
                            url = value;
                            if (url && typeof url === 'string') {
                                this.uploadImagesInUrl(url);
                            }
                        }
                        return [2];
                }
            });
        });
    };
    Arthur.prototype.pasteImage = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var clipboardData, data, _a, type, value, files, content, MdObj, url;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        clipboardData = Clipboard_1.getClipBoardData(e);
                        if (!clipboardData) {
                            return [2];
                        }
                        if (!clipboardData.then) return [3, 2];
                        return [4, clipboardData];
                    case 1:
                        _a = _b.sent();
                        return [3, 3];
                    case 2:
                        _a = clipboardData;
                        _b.label = 3;
                    case 3:
                        data = _a;
                        e.stopPropagation();
                        type = data.type, value = data.value;
                        if (type !== 'text') {
                            e.preventDefault();
                        }
                        if (type === 'file') {
                            files = value;
                            if (_isArray(files) && files.length > 0) {
                                this.uploadImagesInFile(files);
                            }
                        } else if (type === 'html') {
                            content = value;
                            if (typeof content === 'string') {
                                MdObj = MarkDown_1.getMarkDownObj(content);
                                this.uploadImagesInHtml(MdObj);
                            }
                        } else if (type === 'url' && BrowserDetector_1.isSafari()) {
                            url = value;
                            if (url && typeof url === 'string') {
                                this.uploadImagesInUrl(url);
                            }
                        }
                        return [2];
                }
            });
        });
    };
    Arthur.Events = common_1.replaceValueWithKey(events);
    Arthur.Errors = {
        FILE_NOT_EXIST: 1,
        FILE_TYPE_ERROR: 3,
        FILE_TOO_LARGE: 4
    };
    return Arthur;
}();
module.exports = Arthur;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Autosize 4.0.0
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
		factory(exports, module);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod.exports, mod);
		global.autosize = mod.exports;
	}
})(this, function (exports, module) {
	'use strict';

	var map = typeof Map === "function" ? new Map() : (function () {
		var keys = [];
		var values = [];

		return {
			has: function has(key) {
				return keys.indexOf(key) > -1;
			},
			get: function get(key) {
				return values[keys.indexOf(key)];
			},
			set: function set(key, value) {
				if (keys.indexOf(key) === -1) {
					keys.push(key);
					values.push(value);
				}
			},
			'delete': function _delete(key) {
				var index = keys.indexOf(key);
				if (index > -1) {
					keys.splice(index, 1);
					values.splice(index, 1);
				}
			}
		};
	})();

	var createEvent = function createEvent(name) {
		return new Event(name, { bubbles: true });
	};
	try {
		new Event('test');
	} catch (e) {
		// IE does not support `new Event()`
		createEvent = function (name) {
			var evt = document.createEvent('Event');
			evt.initEvent(name, true, false);
			return evt;
		};
	}

	function assign(ta) {
		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;

		var heightOffset = null;
		var clientWidth = ta.clientWidth;
		var cachedHeight = null;

		function init() {
			var style = window.getComputedStyle(ta, null);

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			ta.style.overflowY = value;
		}

		function getParentOverflows(el) {
			var arr = [];

			while (el && el.parentNode && el.parentNode instanceof Element) {
				if (el.parentNode.scrollTop) {
					arr.push({
						node: el.parentNode,
						scrollTop: el.parentNode.scrollTop
					});
				}
				el = el.parentNode;
			}

			return arr;
		}

		function resize() {
			var originalHeight = ta.style.height;
			var overflows = getParentOverflows(ta);
			var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

			ta.style.height = '';

			var endHeight = ta.scrollHeight + heightOffset;

			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				ta.style.height = originalHeight;
				return;
			}

			ta.style.height = endHeight + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			overflows.forEach(function (el) {
				el.node.scrollTop = el.scrollTop;
			});

			if (docTop) {
				document.documentElement.scrollTop = docTop;
			}
		}

		function update() {
			resize();

			var styleHeight = Math.round(parseFloat(ta.style.height));
			var computed = window.getComputedStyle(ta, null);

			// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
			var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;

			// The actual height not matching the style height (set via the resize method) indicates that
			// the max-height has been exceeded, in which case the overflow should be allowed.
			if (actualHeight !== styleHeight) {
				if (computed.overflowY === 'hidden') {
					changeOverflow('scroll');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			} else {
				// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
				if (computed.overflowY !== 'hidden') {
					changeOverflow('hidden');
					resize();
					actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
				}
			}

			if (cachedHeight !== actualHeight) {
				cachedHeight = actualHeight;
				var evt = createEvent('autosize:resized');
				try {
					ta.dispatchEvent(evt);
				} catch (err) {
					// Firefox will throw an error on dispatchEvent for a detached element
					// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
				}
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = (function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});

			map['delete'](ta);
		}).bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap
		});

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		ta.style.overflowX = 'hidden';
		ta.style.wordWrap = 'break-word';

		map.set(ta, {
			destroy: destroy,
			update: update
		});

		init();
	}

	function destroy(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.destroy();
		}
	}

	function update(ta) {
		var methods = map.get(ta);
		if (methods) {
			methods.update();
		}
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function (el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function (el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	module.exports = autosize;
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_9__;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

var DataTransfer_1 = __webpack_require__(1);
function getClipBoardData(e) {
    var clipboardData = e.clipboardData || window.clipboardData;
    if (!clipboardData) {
        return null;
    }
    return DataTransfer_1.getTransferData(clipboardData, e);
}
exports.getClipBoardData = getClipBoardData;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(13);
exports.encode = exports.stringify = __webpack_require__(14);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

var common_1 = __webpack_require__(0);
var hiddenEditor = function hiddenEditor() {
    var div = document.createElement('div');
    div.setAttribute('contenteditable', 'true');
    div.setAttribute('aria-hidden', 'true');
    div.setAttribute('tabindex', '-1');
    div.setAttribute('style', 'width: 1px; height: 1px; left: -100; position: fixed; overflow: hidden');
    return div;
};
var PasteUtil = function () {
    function PasteUtil(target) {
        this.container = hiddenEditor();
        this.target = target;
        this.getImage = this.getImage.bind(this);
    }
    PasteUtil.prototype.getImage = function () {
        var _this = this;
        document.body.appendChild(this.container);
        this.container.focus();
        return new Promise(function (resolve) {
            setTimeout(function () {
                _this.target.focus();
                _this.getPasteInfo().then(function (data) {
                    resolve(data);
                    document.body.removeChild(_this.container);
                });
            }, 1);
        });
    };
    PasteUtil.prototype.getPasteInfo = function () {
        var img = this.container.querySelector('img');
        var loader = new Image();
        return new Promise(function (resolve) {
            loader.onload = function () {
                var canvas = document.createElement('canvas');
                var width = loader.width,
                    height = loader.height;
                canvas.width = width;
                canvas.height = height;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(loader, 0, 0, canvas.width, canvas.height);
                var dataURL;
                var blob;
                try {
                    dataURL = canvas.toDataURL('image/png');
                    blob = common_1.getFileFromDataURL(dataURL);
                } catch (error) {}
                if (dataURL) {
                    resolve({
                        blob: blob,
                        dataURL: dataURL,
                        width: width,
                        height: height
                    });
                }
            };
            loader.src = img.src;
        });
    };
    return PasteUtil;
}();
exports.default = PasteUtil;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [0, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });

var DataTransfer_1 = __webpack_require__(1);
function getDropData(e) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!e.dataTransfer) {
                return [2, null];
            }
            return [2, DataTransfer_1.getTransferData(e.dataTransfer, e)];
        });
    });
}
exports.getDropData = getDropData;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

var toMarkdown = __webpack_require__(18);
var common_1 = __webpack_require__(0);
function getMarkDownObj(html) {
    var imgIndex = 0;
    var images = [];
    var md = toMarkdown(html, {
        gfm: true,
        converters: [{
            filter: ['em', 'i'],
            replacement: function replacement(content) {
                return '*' + content + '*';
            }
        }, {
            filter: 'sub',
            replacement: function replacement(content) {
                return "<sub>" + content + "</sub>";
            }
        }, {
            filter: 'sup',
            replacement: function replacement(content) {
                return "<sup>" + content + "</sup>";
            }
        }, {
            filter: 'img',
            replacement: function replacement(content, node) {
                var id = common_1.getUUID();
                var alt = node.getAttribute('alt') || 'image';
                var src = node.getAttribute('src') || '';
                var title = node.title || '';
                var placeholder = "[\u56FE\u7247\u4E0A\u4F20\u4E2D...(image-" + id + "-" + imgIndex + ")]";
                var img = {
                    id: id,
                    src: src,
                    placeholder: placeholder,
                    alt: alt,
                    title: title
                };
                images.push(img);
                imgIndex++;
                return placeholder + "\n\n";
            }
        }, {
            filter: 'button',
            replacement: function replacement(content) {
                return content + " ";
            }
        }, {
            filter: function filter(node) {
                return node.nodeName === 'DIV' && node.classList.contains('image-caption');
            },
            replacement: function replacement() {
                return '';
            }
        }, {
            filter: 'div',
            replacement: function replacement(content) {
                return '\n\n' + content + '\n\n';
            }
        }, {
            filter: 'span',
            replacement: function replacement(content) {
                return content;
            }
        }, {
            filter: 'font',
            replacement: function replacement(content) {
                return content;
            }
        }, {
            filter: 'section',
            replacement: function replacement(content) {
                return content;
            }
        }, {
            filter: 'aside',
            replacement: function replacement(content) {
                return content;
            }
        }, {
            filter: 'figure',
            replacement: function replacement(content) {
                return content;
            }
        }, {
            filter: function filter(node) {
                return node.nodeName === 'A' && !node.getAttribute('href');
            },
            replacement: function replacement(content) {
                return content;
            }
        }]
    });
    return {
        md: md,
        images: images.reverse()
    };
}
exports.getMarkDownObj = getMarkDownObj;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * to-markdown - an HTML to Markdown converter
 *
 * Copyright 2011+, Dom Christie
 * Licenced under the MIT licence
 *
 */



var toMarkdown
var converters
var mdConverters = __webpack_require__(19)
var gfmConverters = __webpack_require__(20)
var HtmlParser = __webpack_require__(21)
var collapse = __webpack_require__(23)

/*
 * Utilities
 */

var blocks = ['address', 'article', 'aside', 'audio', 'blockquote', 'body',
  'canvas', 'center', 'dd', 'dir', 'div', 'dl', 'dt', 'fieldset', 'figcaption',
  'figure', 'footer', 'form', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'header', 'hgroup', 'hr', 'html', 'isindex', 'li', 'main', 'menu', 'nav',
  'noframes', 'noscript', 'ol', 'output', 'p', 'pre', 'section', 'table',
  'tbody', 'td', 'tfoot', 'th', 'thead', 'tr', 'ul'
]

function isBlock (node) {
  return blocks.indexOf(node.nodeName.toLowerCase()) !== -1
}

var voids = [
  'area', 'base', 'br', 'col', 'command', 'embed', 'hr', 'img', 'input',
  'keygen', 'link', 'meta', 'param', 'source', 'track', 'wbr'
]

function isVoid (node) {
  return voids.indexOf(node.nodeName.toLowerCase()) !== -1
}

function htmlToDom (string) {
  var tree = new HtmlParser().parseFromString(string, 'text/html')
  collapse(tree.documentElement, isBlock)
  return tree
}

/*
 * Flattens DOM tree into single array
 */

function bfsOrder (node) {
  var inqueue = [node]
  var outqueue = []
  var elem
  var children
  var i

  while (inqueue.length > 0) {
    elem = inqueue.shift()
    outqueue.push(elem)
    children = elem.childNodes
    for (i = 0; i < children.length; i++) {
      if (children[i].nodeType === 1) inqueue.push(children[i])
    }
  }
  outqueue.shift()
  return outqueue
}

/*
 * Contructs a Markdown string of replacement text for a given node
 */

function getContent (node) {
  var text = ''
  for (var i = 0; i < node.childNodes.length; i++) {
    if (node.childNodes[i].nodeType === 1) {
      text += node.childNodes[i]._replacement
    } else if (node.childNodes[i].nodeType === 3) {
      text += node.childNodes[i].data
    } else continue
  }
  return text
}

/*
 * Returns the HTML string of an element with its contents converted
 */

function outer (node, content) {
  return node.cloneNode(false).outerHTML.replace('><', '>' + content + '<')
}

function canConvert (node, filter) {
  if (typeof filter === 'string') {
    return filter === node.nodeName.toLowerCase()
  }
  if (Array.isArray(filter)) {
    return filter.indexOf(node.nodeName.toLowerCase()) !== -1
  } else if (typeof filter === 'function') {
    return filter.call(toMarkdown, node)
  } else {
    throw new TypeError('`filter` needs to be a string, array, or function')
  }
}

function isFlankedByWhitespace (side, node) {
  var sibling
  var regExp
  var isFlanked

  if (side === 'left') {
    sibling = node.previousSibling
    regExp = / $/
  } else {
    sibling = node.nextSibling
    regExp = /^ /
  }

  if (sibling) {
    if (sibling.nodeType === 3) {
      isFlanked = regExp.test(sibling.nodeValue)
    } else if (sibling.nodeType === 1 && !isBlock(sibling)) {
      isFlanked = regExp.test(sibling.textContent)
    }
  }
  return isFlanked
}

function flankingWhitespace (node, content) {
  var leading = ''
  var trailing = ''

  if (!isBlock(node)) {
    var hasLeading = /^[ \r\n\t]/.test(content)
    var hasTrailing = /[ \r\n\t]$/.test(content)

    if (hasLeading && !isFlankedByWhitespace('left', node)) {
      leading = ' '
    }
    if (hasTrailing && !isFlankedByWhitespace('right', node)) {
      trailing = ' '
    }
  }

  return { leading: leading, trailing: trailing }
}

/*
 * Finds a Markdown converter, gets the replacement, and sets it on
 * `_replacement`
 */

function process (node) {
  var replacement
  var content = getContent(node)

  // Remove blank nodes
  if (!isVoid(node) && !/A|TH|TD/.test(node.nodeName) && /^\s*$/i.test(content)) {
    node._replacement = ''
    return
  }

  for (var i = 0; i < converters.length; i++) {
    var converter = converters[i]

    if (canConvert(node, converter.filter)) {
      if (typeof converter.replacement !== 'function') {
        throw new TypeError(
          '`replacement` needs to be a function that returns a string'
        )
      }

      var whitespace = flankingWhitespace(node, content)

      if (whitespace.leading || whitespace.trailing) {
        content = content.trim()
      }
      replacement = whitespace.leading +
        converter.replacement.call(toMarkdown, content, node) +
        whitespace.trailing
      break
    }
  }

  node._replacement = replacement
}

toMarkdown = function (input, options) {
  options = options || {}

  if (typeof input !== 'string') {
    throw new TypeError(input + ' is not a string')
  }

  if (input === '') {
    return ''
  }

  // Escape potential ol triggers
  input = input.replace(/(\d+)\. /g, '$1\\. ')

  var clone = htmlToDom(input).body
  var nodes = bfsOrder(clone)
  var output

  converters = mdConverters.slice(0)
  if (options.gfm) {
    converters = gfmConverters.concat(converters)
  }

  if (options.converters) {
    converters = options.converters.concat(converters)
  }

  // Process through nodes in reverse (so deepest child elements are first).
  for (var i = nodes.length - 1; i >= 0; i--) {
    process(nodes[i])
  }
  output = getContent(clone)

  return output.replace(/^[\t\r\n]+|[\t\r\n\s]+$/g, '')
    .replace(/\n\s+\n/g, '\n\n')
    .replace(/\n{3,}/g, '\n\n')
}

toMarkdown.isBlock = isBlock
toMarkdown.isVoid = isVoid
toMarkdown.outer = outer

module.exports = toMarkdown


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [
  {
    filter: 'p',
    replacement: function (content) {
      return '\n\n' + content + '\n\n'
    }
  },

  {
    filter: 'br',
    replacement: function () {
      return '  \n'
    }
  },

  {
    filter: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    replacement: function (content, node) {
      var hLevel = node.nodeName.charAt(1)
      var hPrefix = ''
      for (var i = 0; i < hLevel; i++) {
        hPrefix += '#'
      }
      return '\n\n' + hPrefix + ' ' + content + '\n\n'
    }
  },

  {
    filter: 'hr',
    replacement: function () {
      return '\n\n* * *\n\n'
    }
  },

  {
    filter: ['em', 'i'],
    replacement: function (content) {
      return '_' + content + '_'
    }
  },

  {
    filter: ['strong', 'b'],
    replacement: function (content) {
      return '**' + content + '**'
    }
  },

  // Inline code
  {
    filter: function (node) {
      var hasSiblings = node.previousSibling || node.nextSibling
      var isCodeBlock = node.parentNode.nodeName === 'PRE' && !hasSiblings

      return node.nodeName === 'CODE' && !isCodeBlock
    },
    replacement: function (content) {
      return '`' + content + '`'
    }
  },

  {
    filter: function (node) {
      return node.nodeName === 'A' && node.getAttribute('href')
    },
    replacement: function (content, node) {
      var titlePart = node.title ? ' "' + node.title + '"' : ''
      return '[' + content + '](' + node.getAttribute('href') + titlePart + ')'
    }
  },

  {
    filter: 'img',
    replacement: function (content, node) {
      var alt = node.alt || ''
      var src = node.getAttribute('src') || ''
      var title = node.title || ''
      var titlePart = title ? ' "' + title + '"' : ''
      return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : ''
    }
  },

  // Code blocks
  {
    filter: function (node) {
      return node.nodeName === 'PRE' && node.firstChild.nodeName === 'CODE'
    },
    replacement: function (content, node) {
      return '\n\n    ' + node.firstChild.textContent.replace(/\n/g, '\n    ') + '\n\n'
    }
  },

  {
    filter: 'blockquote',
    replacement: function (content) {
      content = content.trim()
      content = content.replace(/\n{3,}/g, '\n\n')
      content = content.replace(/^/gm, '> ')
      return '\n\n' + content + '\n\n'
    }
  },

  {
    filter: 'li',
    replacement: function (content, node) {
      content = content.replace(/^\s+/, '').replace(/\n/gm, '\n    ')
      var prefix = '*   '
      var parent = node.parentNode
      if (parent.nodeName === 'OL') {
        var start = parent.getAttribute('start')
        var index = Array.prototype.indexOf.call(parent.children, node)
        prefix = (start ? Number(start) + index : index + 1) + '.  '
      }

      return prefix + content
    }
  },

  {
    filter: ['ul', 'ol'],
    replacement: function (content, node) {
      var strings = []
      for (var i = 0; i < node.childNodes.length; i++) {
        strings.push(node.childNodes[i]._replacement)
      }

      if (/li/i.test(node.parentNode.nodeName)) {
        return '\n' + strings.join('\n')
      }
      return '\n\n' + strings.join('\n') + '\n\n'
    }
  },

  {
    filter: function (node) {
      return this.isBlock(node)
    },
    replacement: function (content, node) {
      return '\n\n' + this.outer(node, content) + '\n\n'
    }
  },

  // Anything else!
  {
    filter: function () {
      return true
    },
    replacement: function (content, node) {
      return this.outer(node, content)
    }
  }
]


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function cell (content, node) {
  var index = Array.prototype.indexOf.call(node.parentNode.childNodes, node)
  var prefix = ' '
  if (index === 0) prefix = '| '
  return prefix + content + ' |'
}

var highlightRegEx = /highlight highlight-(\S+)/

module.exports = [
  {
    filter: 'br',
    replacement: function () {
      return '\n'
    }
  },
  {
    filter: ['del', 's', 'strike'],
    replacement: function (content) {
      return '~~' + content + '~~'
    }
  },

  {
    filter: function (node) {
      return node.type === 'checkbox' && node.parentNode.nodeName === 'LI'
    },
    replacement: function (content, node) {
      return (node.checked ? '[x]' : '[ ]') + ' '
    }
  },

  {
    filter: ['th', 'td'],
    replacement: function (content, node) {
      return cell(content, node)
    }
  },

  {
    filter: 'tr',
    replacement: function (content, node) {
      var borderCells = ''
      var alignMap = { left: ':--', right: '--:', center: ':-:' }

      if (node.parentNode.nodeName === 'THEAD') {
        for (var i = 0; i < node.childNodes.length; i++) {
          var align = node.childNodes[i].attributes.align
          var border = '---'

          if (align) border = alignMap[align.value] || border

          borderCells += cell(border, node.childNodes[i])
        }
      }
      return '\n' + content + (borderCells ? '\n' + borderCells : '')
    }
  },

  {
    filter: 'table',
    replacement: function (content) {
      return '\n\n' + content + '\n\n'
    }
  },

  {
    filter: ['thead', 'tbody', 'tfoot'],
    replacement: function (content) {
      return content
    }
  },

  // Fenced code blocks
  {
    filter: function (node) {
      return node.nodeName === 'PRE' &&
      node.firstChild &&
      node.firstChild.nodeName === 'CODE'
    },
    replacement: function (content, node) {
      return '\n\n```\n' + node.firstChild.textContent + '\n```\n\n'
    }
  },

  // Syntax-highlighted code blocks
  {
    filter: function (node) {
      return node.nodeName === 'PRE' &&
      node.parentNode.nodeName === 'DIV' &&
      highlightRegEx.test(node.parentNode.className)
    },
    replacement: function (content, node) {
      var language = node.parentNode.className.match(highlightRegEx)[1]
      return '\n\n```' + language + '\n' + node.textContent + '\n```\n\n'
    }
  },

  {
    filter: function (node) {
      return node.nodeName === 'DIV' &&
      highlightRegEx.test(node.className)
    },
    replacement: function (content) {
      return '\n\n' + content + '\n\n'
    }
  }
]


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Set up window for Node.js
 */

var _window = (typeof window !== 'undefined' ? window : this)

/*
 * Parsing HTML strings
 */

function canParseHtmlNatively () {
  var Parser = _window.DOMParser
  var canParse = false

  // Adapted from https://gist.github.com/1129031
  // Firefox/Opera/IE throw errors on unsupported types
  try {
    // WebKit returns null on unsupported types
    if (new Parser().parseFromString('', 'text/html')) {
      canParse = true
    }
  } catch (e) {}

  return canParse
}

function createHtmlParser () {
  var Parser = function () {}

  // For Node.js environments
  if (typeof document === 'undefined') {
    var jsdom = __webpack_require__(22)
    Parser.prototype.parseFromString = function (string) {
      return jsdom.jsdom(string, {
        features: {
          FetchExternalResources: [],
          ProcessExternalResources: false
        }
      })
    }
  } else {
    if (!shouldUseActiveX()) {
      Parser.prototype.parseFromString = function (string) {
        var doc = document.implementation.createHTMLDocument('')
        doc.open()
        doc.write(string)
        doc.close()
        return doc
      }
    } else {
      Parser.prototype.parseFromString = function (string) {
        var doc = new window.ActiveXObject('htmlfile')
        doc.designMode = 'on' // disable on-page scripts
        doc.open()
        doc.write(string)
        doc.close()
        return doc
      }
    }
  }
  return Parser
}

function shouldUseActiveX () {
  var useActiveX = false

  try {
    document.implementation.createHTMLDocument('').open()
  } catch (e) {
    if (window.ActiveXObject) useActiveX = true
  }

  return useActiveX
}

module.exports = canParseHtmlNatively() ? _window.DOMParser : createHtmlParser()


/***/ }),
/* 22 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var voidElements = __webpack_require__(24);
Object.keys(voidElements).forEach(function (name) {
  voidElements[name.toUpperCase()] = 1;
});

var blockElements = {};
__webpack_require__(25).forEach(function (name) {
  blockElements[name.toUpperCase()] = 1;
});

/**
 * isBlockElem(node) determines if the given node is a block element.
 *
 * @param {Node} node
 * @return {Boolean}
 */
function isBlockElem(node) {
  return !!(node && blockElements[node.nodeName]);
}

/**
 * isVoid(node) determines if the given node is a void element.
 *
 * @param {Node} node
 * @return {Boolean}
 */
function isVoid(node) {
  return !!(node && voidElements[node.nodeName]);
}

/**
 * whitespace(elem [, isBlock]) removes extraneous whitespace from an
 * the given element. The function isBlock may optionally be passed in
 * to determine whether or not an element is a block element; if none
 * is provided, defaults to using the list of block elements provided
 * by the `block-elements` module.
 *
 * @param {Node} elem
 * @param {Function} blockTest
 */
function collapseWhitespace(elem, isBlock) {
  if (!elem.firstChild || elem.nodeName === 'PRE') return;

  if (typeof isBlock !== 'function') {
    isBlock = isBlockElem;
  }

  var prevText = null;
  var prevVoid = false;

  var prev = null;
  var node = next(prev, elem);

  while (node !== elem) {
    if (node.nodeType === 3) {
      // Node.TEXT_NODE
      var text = node.data.replace(/[ \r\n\t]+/g, ' ');

      if ((!prevText || / $/.test(prevText.data)) && !prevVoid && text[0] === ' ') {
        text = text.substr(1);
      }

      // `text` might be empty at this point.
      if (!text) {
        node = remove(node);
        continue;
      }

      node.data = text;
      prevText = node;
    } else if (node.nodeType === 1) {
      // Node.ELEMENT_NODE
      if (isBlock(node) || node.nodeName === 'BR') {
        if (prevText) {
          prevText.data = prevText.data.replace(/ $/, '');
        }

        prevText = null;
        prevVoid = false;
      } else if (isVoid(node)) {
        // Avoid trimming space around non-block, non-BR void elements.
        prevText = null;
        prevVoid = true;
      }
    } else {
      node = remove(node);
      continue;
    }

    var nextNode = next(prev, node);
    prev = node;
    node = nextNode;
  }

  if (prevText) {
    prevText.data = prevText.data.replace(/ $/, '');
    if (!prevText.data) {
      remove(prevText);
    }
  }
}

/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */
function remove(node) {
  var next = node.nextSibling || node.parentNode;

  node.parentNode.removeChild(node);

  return next;
}

/**
 * next(prev, current) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @return {Node}
 */
function next(prev, current) {
  if (prev && prev.parentNode === current || current.nodeName === 'PRE') {
    return current.nextSibling || current.parentNode;
  }

  return current.firstChild || current.nextSibling || current.parentNode;
}

module.exports = collapseWhitespace;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `build.js`.
 * Do not manually edit.
 */

module.exports = [
  "address",
  "article",
  "aside",
  "blockquote",
  "canvas",
  "dd",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "hr",
  "li",
  "main",
  "nav",
  "noscript",
  "ol",
  "output",
  "p",
  "pre",
  "section",
  "table",
  "tfoot",
  "ul",
  "video"
];


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

var _range = __webpack_require__(27);
var _last = __webpack_require__(28);
var BrowserDetector_1 = __webpack_require__(3);
function mockInput(el) {
    var event;

    if (typeof Event === 'function') {
        event = new Event('input');
    } else {
        event = document.createEvent('Event');
        event.initEvent('input', false, false);
    }
    el.dispatchEvent(event);
}
exports.mockInput = mockInput;

function insertText(el, text) {
    el.focus();
    var result = false;
    if (BrowserDetector_1.canInsertText()) {
        document.execCommand('insertText', false, text);
        result = true;
    } else if (BrowserDetector_1.canUseSelection()) {
        var elValue = el.value;
        var before = elValue.substring(0, el.selectionStart);
        var after = elValue.substring(el.selectionEnd, elValue.length);
        var pos = el.selectionStart + text.length;
        el.value = before + text + after;
        el.selectionStart = el.selectionEnd = pos;
        mockInput(el);
        result = true;
    }
    return result;
}
exports.insertText = insertText;

function deleteSpace(el, num) {
    var elValue = el.value;
    var result = false;
    if (num > 0 && BrowserDetector_1.canUseSelection()) {
        var pos_1 = el.selectionStart;
        var arr = _range(1, num + 1).map(function (v) {
            return +(elValue[pos_1 - v] === ' ');
        });
        var spaceNum = arr.reduce(function (x, y) {
            return x + y;
        }, 0);
        var offset = Math.min(num, spaceNum);
        if (offset > 0) {
            if (BrowserDetector_1.canInsertText()) {
                el.selectionEnd = pos_1;
                el.selectionStart = pos_1 - offset;
                document.execCommand('delete', false, null);
                result = true;
            } else {
                var before = elValue.substring(0, pos_1 - offset);
                var after = elValue.substring(pos_1, elValue.length);
                el.value = before + after;

                el.selectionStart = el.selectionEnd = pos_1 - offset;
                mockInput(el);
                result = true;
            }
        }
    }
    return result;
}
exports.deleteSpace = deleteSpace;
var start = 0;
var end = 0;

function replaceAllPlaceholder(el, oldStr, newStr, alt, isFirst) {
    var elValue = el.value;
    var content = elValue.split(oldStr);
    var result = content.join(newStr);
    var beforeTop = el.scrollTop;
    var pos = result.length - _last(content).length;
    if (BrowserDetector_1.canInsertText() && BrowserDetector_1.canUseSelection()) {
        el.selectionStart = 0;
        el.selectionEnd = elValue.length;
        insertText(el, result);
    } else {
        el.value = result;
        mockInput(el);
    }
    el.scrollTop = beforeTop;
    if (alt && isFirst) {
        start = pos - newStr.length + 2;
        end = start + alt.length;
    }
    el.selectionStart = start;
    el.selectionEnd = end;
    return pos;
}
exports.replaceAllPlaceholder = replaceAllPlaceholder;
function resetSelection(el, pos) {
    el.selectionStart = el.selectionEnd = pos;
}
exports.resetSelection = resetSelection;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_27__;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_28__;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

var keyCode = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    TAB: 9,
    CAP: 20,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    COMMAND: 91,
    WIN: 92,
    BACKSPACE: 8,
    DELETE: 46,
    SPACE: 32,
    ENTER: 13,
    ESC: 27,
    PAGE_UP: 33,
    PAGE_DOWN: 34
};
exports.default = keyCode;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });

var _includes = __webpack_require__(2);
var EventEmitter = function () {
    function EventEmitter() {
        this.all = {};
        this.isStop = false;
    }
    EventEmitter.prototype.on = function (type, handler) {
        if (!this.all[type]) {
            this.all[type] = [];
        }
        if (!_includes(this.all[type], handler)) {
            this.all[type].push(handler);
        }
    };
    EventEmitter.prototype.off = function (type, handler) {
        if (this.all[type]) {
            this.all[type].splice(this.all[type].indexOf(handler) >>> 0, 1);
        }
    };
    EventEmitter.prototype.emit = function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.isStop) {
            (this.all[type] || []).map(function (handler) {
                handler.apply(void 0, args);
            });
        }
    };
    EventEmitter.prototype.destroy = function (type) {
        this.all[type] = [];
    };
    EventEmitter.prototype.startEmit = function () {
        this.isStop = false;
    };

    EventEmitter.prototype.stopEmit = function () {
        this.isStop = true;
    };

    EventEmitter.prototype.destroyAll = function () {
        this.all = {};
    };
    return EventEmitter;
}();
exports.default = EventEmitter;

/***/ })
/******/ ]);
});
//# sourceMappingURL=Arthur-v1.0.0.js.map


// WEBPACK FOOTER //
// ./src/assets/vendors/Arthur-v1.0.0.js